"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingEndedModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _ModalTypes = require("../../../constants/ModalTypes");
var _Refresh = require("../../../components/Modals/Refresh/Refresh");
var _useTranslate2 = require("../../../locales/useTranslate");
var modalMessage = {
  TaskFailed: 'MeetingEnded_TaskFailed_Message',
  AudioJoinedFromAnotherDevice: 'MeetingEnded_AudioJoinedFromAnotherDevice_Message'
};
var modalTitle = {
  TaskFailed: 'MeetingEnded_TaskFailed_Title',
  AudioJoinedFromAnotherDevice: 'MeetingEnded_AudioJoinedFromAnotherDevice_Title'
};
var modalMessageSuffix = {
  TaskFailed: 'MeetingEnded_TaskFailed_MessageSuffix'
};
function getInitialValueMessage(initialValue, translate) {
  var _ref;
  return (_ref = modalMessage[initialValue] && translate(modalMessage[initialValue])) !== null && _ref !== void 0 ? _ref : "The meeting ended with the following: ".concat(initialValue);
}
var MeetingEndedModal = exports.MeetingEndedModal = function MeetingEndedModal() {
  var modal = (0, _reactRedux.useSelector)(function (state) {
    return state.modal;
  }, _reactRedux.shallowEqual);
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var location = (0, _reactRouterDom.useLocation)();
  var isOpen = modal && modal.type === _ModalTypes.MEETING_ENDED_MODAL;
  var initialValue = modal === null || modal === void 0 ? void 0 : modal.initialValue;
  // This applies to only director pro, but its harmless to the other apps to have it in here
  var isScenePreview = location.pathname.includes('/scene');
  var isJoinPath = location.pathname.includes('/join');
  var isExcludedPath = isScenePreview || isJoinPath;
  var shouldShowModal = isOpen && !isExcludedPath;
  return /*#__PURE__*/_react["default"].createElement(_Refresh.RefreshModal, {
    isOpen: shouldShowModal,
    title: modalTitle[initialValue] ? translate(modalTitle[initialValue]) : translate('MeetingEnded_Default_Title')
  }, initialValue ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, getInitialValueMessage(initialValue, translate)), modalMessageSuffix[initialValue] ? /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      fontStyle: 'italic'
    }
  }, translate(modalMessageSuffix[initialValue])) : null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "This Studio page needs to be restarted due to no recent activity by speaker cameras or microphone. Studio sessions with less than 2", ' ', "speaker sources time out after 30m.")));
};
MeetingEndedModal.propTypes = {};